import React from 'react';
import CorePage from '../../views/core/CorePage';
import desktoporlaptop from '../../images/icons/desktoporlaptop.png'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

export default class Errmsg extends CorePage{
	
	constructor(props) {
		super(props);
		
	}

	getImageURL(){
		if(this.props.errormsg.srcval=='desktoporlaptop'){
			return desktoporlaptop;
		}
	}

	render(){
		return(
			<div >
				<div>
					<h2>{this.props.errormsg.heading}</h2>
				</div>
				<div style={{paddingBottom: '30px'}}>
					<img src={this.getImageURL()}/>
				</div>
				<div>
				{ReactHtmlParser(this.props.errormsg.description)}
				</div>
			</div>
		)
	}

}


// WEBPACK FOOTER //
// ./src/views/lesson/Errmsg.js